// extracted by mini-css-extract-plugin
module.exports = {"container":"Alert_container__3wuOW","titleContainer":"Alert_titleContainer__35Q1y","text":"Alert_text__35nC-","title":"Alert_title__2wUtX","hide":"Alert_hide__1IDI9"};